export { default as MenuIcon } from './menu.svg';
export { default as HerondPortalIcon } from './logo-hp.svg';
export { default as SystemIcon } from './system.svg';
export { default as HerondIcon } from './herond.svg';
export { default as HerondIdIcon } from './herond-id.svg';
export { default as HomeIcon } from './home.svg';
